export const SET_LOGO = 'SET_LOGO'
export const SET_LOGO_PRESET_PROPERTY = 'SET_LOGO_PRESET_PROPERTY'

export const SET_SVG = 'SET_SVG'

export const SET_PALETTE_HEX = 'SET_PALETTE_HEX'

export const SET_PALETTE_PROPERTY = 'SET_PALETTE_PROPERTY'

export const SET_TEMPLATE_PREVIEWS = 'SET_TEMPLATE_PREVIEWS'
export const ADD_TEMPLATE_PREVIEWS = 'ADD_TEMPLATE_PREVIEWS'

export const SET_ASSET_LIST = 'SET_ASSET_LIST'

export const ADD_TO_PALETTES = 'ADD_TO_PALETTES'

export const ADD_PALETTE_COLOR = 'ADD_PALETTE_COLOR'

export const SET_PALETTE_COLORS = 'SET_PALETTE_COLORS'

export const SET_ICON_SEARCH_STRING = 'SET_ICON_SEARCH_STRING'

export const SET_ICON_SEARCH_RESULTS = 'SET_ICON_SEARCH_RESULTS'
export const ADD_NOUN_PROJECT_RESULTS = 'ADD_NOUN_PROJECT_RESULTS'

export const TOGGLE_LOADING_OVERLAY_VISIBILITY =
  'TOGGLE_LOADING_OVERLAY_VISIBILITY'

export const SET_UNVALIDATED_SLOGAN = 'SET_UNVALIDATED_SLOGAN'
export const SET_UNVALIDATED_WORDMARK = 'SET_UNVALIDATED_WORDMARK'
export const SET_UNVALIDATED_KEYWORDS = 'SET_UNVALIDATED_KEYWORDS'
export const SET_CUSTOM_KEYWORDS = 'SET_CUSTOM_KEYWORDS'

export const SET_ICON_SCALE = 'SET_ICON_SCALE'
export const SET_ICON_ORIENTATION = 'SET_ICON_ORIENTATION'
export const SET_ICON_VERTICAL_OFFSET = 'SET_ICON_VERTICAL_OFFSET'
export const SET_ICON_HORIZONTAL_OFFSET = 'SET_ICON_HORIZONTAL_OFFSET'

export const SET_SLOGAN_ALIGNMENT = 'SET_SLOGAN_ALIGNMENT'
export const SET_WORDMARK_ALIGNMENT = 'SET_WORDMARK_ALIGNMENT'

export const SET_TEMPLATE_ALIGNMENT = 'SET_TEMPLATE_ALIGNMENT'
export const SET_SHAPE = 'SET_SHAPE'

export const SET_WORDMARK_MULTICOLOR = 'SET_WORDMARK_MULTICOLOR'
export const SET_WORDMARK_MULTILINE = 'SET_WORDMARK_MULTILINE'
export const SET_SLOGAN_MULTICOLOR = 'SET_SLOGAN_MULTICOLOR'
export const SET_SLOGAN_MULTILINE = 'SET_SLOGAN_MULTILINE'
export const SET_SLOGAN_SCALE = 'SET_SLOGAN_SCALE'

export const SET_SELECTED_ICONS = 'SET_SELECTED_ICONS'
export const TOGGLE_SELECTED_ICON = 'TOGGLE_SELECTED_ICON'

export const SET_ICON_VISIBILITY = 'SET_ICON_VISIBILITY'
export const SET_FONT_CATEGORIES = 'SET_FONT_CATEGORIES'
export const SET_FONT_TYPES = 'SET_FONT_TYPES'
export const TOGGLE_FONT_CATEGORIES = 'TOGGLE_FONT_CATEGORIES'
export const SET_PALETTE_THEME = 'SET_PALETTE_THEME'
export const TOGGLE_PALETTE_THEME = 'TOGGLE_PALETTE_THEME'

export const RESET = 'RESET'
export const SET_MODE = 'SET_MODE'
export const SET_SCOPE = 'SET_SCOPE'
export const SET_FEATURES = 'SET_FEATURES'

export const INCR_UPDATE_KEY = 'INCR_UPDATE_KEY'

export const MOVE_FONT_TO_TOP_OF_LIST = 'MOVE_FONT_TO_TOP_OF_LIST'

export const INCREMENT_REFRESH_KEY = 'INCREMENT_REFRESH_KEY'
export const SET_TIGHT_BOUNDS = 'SET_TIGHT_BOUNDS'
export const SET_WORDMARK_SCRIPT = 'SET_WORDMARK_SCRIPT'

export const SET_MASK_STROKE = 'SET_MASK_STROKE'
export const SET_GRADIENT_PALETTES = 'SET_GRADIENT_PALETTES'
export const SET_MONOGRAM_TEXT = 'SET_MONOGRAM_TEXT'
export const SET_HAS_MORE_PALETTES = 'SET_HAS_MORE_PALETTES'
